import O1HD from "../../../engines/gameEngine";
import data_control from "../../../engines/libs/data_control";
import { PLATFORM_CODE } from "../../../engines/services/ossService";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../BundleResourceConfig";
import { openOreEndInterface, openOreEndMap, openOreEventInterface, openOreStartInterface } from "../prefab/openOreGame/openOreConst";
import openOreGameObj from "../prefab/openOreGame/openOreGameObj";

import { NormalBackpackI } from "./DefineInterface";
import NormalGameManager from "./NormalGameManager";

export default class openOreManager{

    manager:NormalGameManager = null;

    constructor(manager:NormalGameManager){
        this.manager = manager;
        this.openOreStartMap = new openOreBasicMap();
        this.loadConfigs();
    }
    openOreStartMap:openOreBasicMap = {};
    openOreEndMap :openOreEndMap = {};

    openOreStartJson:openOreStartInterface[] = [];
    openOreEndJson = [];

    async loadConfigs(){
        return new Promise<void>(async resolve=>{
            let configArys:string[] = [
                "openOreGameAssets/config/openOreGameStartConfig",
            ];
            if (O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5) {
                let strEndC = "openOreGameAssets/config/openOreGameEndConfigH5";
                configArys.push(strEndC);
            } else {
                let strEndC = "openOreGameAssets/config/openOreGameEndConfig";
                configArys.push(strEndC);
            }


            let bundle = await getOneBundle(BUNDLE_SMALL_NAME.openOreGameBundle);
            bundle.load( configArys,cc.JsonAsset,(err,asset:cc.JsonAsset[])=>{
                if(err){
                    console.log("加载开矿石配置表失败",err);
                    this.openOreEndMap = {};
                    return;
                }
                this.openOreStartJson = asset[0].json;
                this.openOreEndJson   = asset[1].json;

                for(let item of this.openOreEndJson){
                    item = JSON.parse(JSON.stringify(item));
                    this.openOreEndMap[item.id] = item;
                    if(item["incidents"] == ""){
                        item["incidents"] = [];
                    }else{
                        let s = item["incidents"];
                        item["incidents"] = JSON.parse(JSON.stringify(s));
                    }
                }
                for( let item of this.openOreStartJson ){
                    //循环记录
                    let infoEntity : { 
                        id : number 
                        ,Gear : number 
                        ,onePosX:number 
                        ,onePosY:number
                        ,twoPosX:number
                        ,twoPosY:number
                        , weight : number
                        ,explain:string 
                        , price:number 
                        ,bindBackId:number
                        ,stoneName:string
                        ,incidents:openOreEventInterface[]
                    } = {
                        id : item['id'],
                        Gear : item["Gear"],
                        weight : item["weight"],
                        explain : item["explain"],
                        price : item["price"],
                        bindBackId: item["bindBackId"],
                        stoneName:item["stoneName"],
                        incidents:item["incidents"],
                        onePosX:item["onePosX"],
                        onePosY:item["onePosY"],
                        twoPosY:item["twoPosY"],
                        twoPosX:item["twoPosX"]
                    };
                    let basicEntity : openOreBasicI = {
                        icon : item["icon"],
                        infoArray : [infoEntity]
                    };
                    //封装属性
                    if ( this.openOreStartMap [ item["Gear"]] ) {
                        //如果存在
                        let gamblerBasicEntity = this.openOreStartMap[item["Gear"]].find(( tempItem ,index ,dataList )=>{
                            return tempItem.icon == item["icon"];
                        });

                        if ( gamblerBasicEntity ) {
                            gamblerBasicEntity.infoArray.push( infoEntity );
                        }else{
                            this.openOreStartMap[ item["Gear"]].push( basicEntity );
                        }
                    }else{
                        this.openOreStartMap[item["Gear"]] = [];
                        this.openOreStartMap[item["Gear"]].push( basicEntity );
                    }
                }
                //转换配置文件
                // console.log('gamblerStartJson', this.gamblerStartMap);
                resolve();
            });
        });
    }

    getOneTypeEnd(type:number){
        // let iType:string = type.toString();
        // let endAry:openOreEndInterface[] = [];
        // for(let k in this.openOreEndMap){
        //     let end = this.openOreEndMap[k];
        //     if(end.ys_id == iType){
        //         endAry.push(end);
        //     }
        // }
        // let weightAry:number[] = [];
        // for(let i =0;i<endAry.length;i++){
        //     let end = endAry[i];
        //     let endPro = end.pro;
        //     weightAry.push(endPro);
        // }
        // let index = data_control.getRandIPosByWeights(weightAry);
        // return endAry[index];
    }

    getOneStartDataByBackpackItem(backpackItem:NormalBackpackI){
        let id = backpackItem.id;
        let startAry:openOreStartInterface[] = [];
        for(let k in this.openOreStartJson){
            let clam = this.openOreStartJson[k];
            if(clam.bindBackId == id){
                startAry.push(clam);
            }
        }
        if(startAry.length > 0){
            let randItem = data_control.getRandItemOfArray(startAry);
            return randItem;
        }else{
            console.log(`背包物品：${backpackItem.name}未绑定矿石，请检查配置表 errCode:#clamShellManager`);
        }
        return null       
    }

}

/**
 * 基础Map
 */
export class openOreBasicMap {
    [ gear : number] : openOreBasicI[];
}
//基础接口
export interface openOreBasicI {
    icon : string;
    infoArray : { id : number,onePosX:number,onePosY:number,twoPosX:number,twoPosY:number,Gear : number,weight : number,explain:string,price:number,bindBackId:number,stoneName:string,incidents:openOreEventInterface[]}[],
}